import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

import type { DiagnosticRating } from '@malou-io/package-utils';

import { RatingChipComponent } from ':modules/rating-chip/rating-chip.component';

@Component({
    selector: 'app-rating-bloc',
    standalone: true,
    imports: [RatingChipComponent, NgClass],
    templateUrl: './rating-bloc.component.html',
    styleUrl: './rating-bloc.component.scss',
})
export class RatingBlocComponent {
    title = input.required<string>();
    text = input.required<string>();
    rating = input.required<DiagnosticRating>();
    isInverted = input<boolean>(false);
}
